import {
  completeQueryResult,
  hasCompleteQueryData,
  throwOnQueryError,
} from 'ZalamoLibrary/src/lib/core/graphql/complete-query-data';

import { Observable, filter, map, pipe } from 'rxjs';

import { Pipe, PipeTransform } from '@angular/core';
import { GetPublicSessionOrganizationGroupsGQL } from '../../../../../../photographer-panel/src/graphql';

@Pipe({
  name: 'publicSessionOrganizationGroupName',
  standalone: false,
})
export class PublicSessionOrganizationGroupNamePipe implements PipeTransform {
  constructor(
    private getPublicSessionOrganizationGroupsGQL: GetPublicSessionOrganizationGroupsGQL,
  ) {}

  transform(
    publicSessionGroupId: string,
    publicSessionOrganizationId: string,
  ): Observable<string> {
    return this.getPublicSessionOrganizationGroupsGQL
      .watch({
        variables: {
          publicSessionOrganizationId,
        },
      })
      .valueChanges.pipe(
        throwOnQueryError,
        filter(hasCompleteQueryData),
        map((apolloQueryResult) => {
          const {
            data: {
              getMinePublicSessionOrganizationGroups: { list },
            },
          } = completeQueryResult(apolloQueryResult);
          return list.find(
            (v) => v.publicSessionOrganizationGroupId === publicSessionGroupId,
          )?.name;
        }),
      );
  }
}
